import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Avatar from "react-avatar";
import { Button, Modal } from "react-bootstrap";
import { fetchJobComment, postJobComment } from '../../store/candidate/actions';
import { updateSelectedJobId } from '../../store/global/actions';
import { formatDate } from '../../utils/utility';

function JobComments(props) {
    const { selectedJobId, updateSelectedJobId, postJobComment } = props;
    const [commentResponse, setCommentResponse] = useState([]);
    const [comment, setComment] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (selectedJobId)
            fetchComments();
    }, [selectedJobId]);

    async function fetchComments() {
        const { fetchJobComment } = props;
        const response = await fetchJobComment({ job_id: selectedJobId });
        setCommentResponse(response);
    }

    const onSave = async () => {
        if (!comment) {
            setError(true);
            return;
        }

        setError(false);
        const { error } = await postJobComment({
            job_id: selectedJobId,
            msg: comment
        });

        if (!error) {
            setComment('');
            fetchComments();
        }
    }

    const handleClose = () => {
        updateSelectedJobId(null);
    }

    return (
        <Modal scrollable show={selectedJobId !== null} backdrop="static" centered onHide={handleClose}>
            <Modal.Header closeButton className="py-2">
                <Modal.Title>Comments</Modal.Title>
            </Modal.Header>
            <Modal.Body className="scroll">
                <textarea placeholder="Add comment" className="form-control fw-500 radius-2"
                    value={comment} onChange={(e) => setComment(e.target.value)} />
                {error && <span className="invalid-feedback d-block">Please enter comment</span>}
                <div className="text-end">
                    <Button variant="outline-primary" className="bg-blue text-white text-capitalize shadow-none px-4 fw-500 rounded-1 my-2" type="button"
                        onClick={onSave}>
                        Save
                    </Button>
                </div>
                {_.map(commentResponse.data, (item, i) => (
                    <div className="my-3" key={i}>
                        <Avatar size="50" round name={`${item.first_name} ${item.last_name}`} src={`${commentResponse.imageurl}/${item.image}`} className="mb-2" />
                        <h6 className="fw-600 mb-1 lh-base">{item.first_name} {item.last_name}</h6>
                        <p className="mb-1 lh-base">{item.comment_text}</p>
                        <span className="mb-0 lh-base text-secondary fs-14">{formatDate(item.created_at, true)}</span>
                    </div>
                ))}
            </Modal.Body>
        </Modal>
    )
}

export default connect(state => ({ selectedJobId: state.global.selectedJobId }), { fetchJobComment, updateSelectedJobId, postJobComment })(JobComments);